import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LocalStorageService } from 'ngx-webstorage';
import { NotificationService } from './../../service/notification.service';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';

import { ProjectManagementService } from './../../service/projectManagement.service';
import { ProjectsPageRequest } from './../../model/management-config/projectPageRequest';
import { GetAllClientsNames, ProjectManagement } from './../../model/management-config/projectManagement';
import { AddProjectComponent } from './add-project/add-project.component';
import { EditProjectComponent } from './edit-project/edit-project.component';

@Component({
  selector: 'app-project-management',
  templateUrl: './project-management.component.html',
  styleUrls: ['./project-management.component.scss']
})
export class ProjectManagementComponent implements OnInit {

  selectedProject: ProjectManagement = new ProjectManagement();
  projectManagement: ProjectManagement[];
  dataSource: MatTableDataSource<ProjectManagement>;

  // searchKeys = [
  //   { id: 0, name: "ProHealth" },
  //   { id: 1, name: "iCare" },
  //   { id: 2, name: "Test" },
  // ];
  // selectedClient: string = "";
  searchKey: string = "";
  clients: GetAllClientsNames[];
  selectedClient: string = "";

  nameFilter = new FormControl();
  isEditClientDisabled: boolean = false;
  isTargetButtonDisabled: boolean = true;
  selection = new SelectionModel<ProjectManagement>(true, []);
  isRadionButtonClicked: boolean = false;

  pageEvent: PageEvent;
  pageIndex: number;
  pageSize: number;
  length: number;
  pageSizeOptions: number[] = [15, 30, 45];
  projectPageRequests = new ProjectsPageRequest();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

 displayedColumns = ['selection', 'clientId', 'clientName', 'projectId', 'projectName', 'projectDesc', 'createdBy', 'createdTimestamp', 'updatedBy', 'updatedTimestamp'];
 constructor(
   private clientManagementService: ProjectManagementService,
   public dialog: MatDialog,
   private _localStorage: LocalStorageService,
   private router: Router) {
 }

 ngOnInit() {
  this._localStorage.store('PageEvent', undefined);
  this.isEditClientDisabled = true;
  this.getProjects();
  this.getClients();
 }

 getProjects(event?: PageEvent, clearPagination?: boolean) {
  if(clearPagination){
    this._localStorage.store('PageEvent', undefined);
  }
   if (event != undefined) {
    this._localStorage.store('PageEvent', event);
    //this.projectPageRequests.clientId = this.selectedClient;
    this.projectPageRequests.pageNum = event.pageIndex;
    this.projectPageRequests.pageSize = event.pageSize;
   }else if (event === undefined || event === null) {
     this.projectPageRequests.pageNum = 0;
     this.projectPageRequests.pageSize = 15;
   }
   this.projectPageRequests.sortBy = "projectName";
     this.projectPageRequests.sortDir = "ASC";
     if (this.selectedClient != undefined && this.selectedClient != null) {
      this.projectPageRequests.clientId = this.selectedClient;
    }
   if(this.searchKey!= undefined && this.searchKey != null){
     this.projectPageRequests.searchValue = this.searchKey.toLowerCase();
   }else{
     this.projectPageRequests.searchValue = '';
   }
   this.clientManagementService.getProjectsList(this.projectPageRequests)
     .subscribe(result => {
       if (!result) {
         return;
       }
       console.log(result);
       this.projectManagement = result.projects;
       this.dataSource = new MatTableDataSource(result.projects);
       this.dataSource.sort = this.sort;
 
       if (event != undefined) {
         this.pageIndex = event.pageIndex;
         this.pageSize = event.pageSize;
         this.length = result.totalCount;
       }
       if (event === undefined || event === null) {
         this.pageIndex = 0;
         this.pageSize = 15;
         this.length = result.totalCount;
       }
       this.nameFilter.valueChanges.subscribe((nameFilterValue) => {
       this.dataSource.data = this.filterOptions(nameFilterValue);
       });
     }, error => console.log(error));
     return event;
 }

 openAddProjectDialog(): void {
  const dialogRef = this.dialog.open(AddProjectComponent, {
   panelClass: 'assign-sch-model',
   data: this.dialog
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log("result " + result);
    this.getProjects(this._localStorage.retrieve('PageEvent'));
  });
  }

  openEditProjectDialog(): void {
   const dialogRef = this.dialog.open(EditProjectComponent, {
    panelClass: 'assign-sch-model',
     data:
       this.selectedProject
   });

   dialogRef.afterClosed().subscribe(result => {
     console.log("result " + result);
     this.getProjects(this._localStorage.retrieve('PageEvent'));
     this.isEditClientDisabled = true;
   });
 }

 reset() {
   this.isEditClientDisabled = true;
   this.isTargetButtonDisabled = true;
   this.isRadionButtonClicked = false;
   this.getProjects();
   this.selection.clear();
 }

//  isAllSelected() {
//    const numSelected = this.selection.selected.length;
//    const numRows = this.dataSource.data.length;
//    return numSelected === numRows;
//  }

//  toggle(row) {
//    console.log(row.firstName + "<>" + this.selection.selected.includes(row))
//    if (this.selection.selected.includes(row)) {
//      this.selection.deselect(row)
//    } else {
//      this.selection.select(row)
//    }
//    if (this.selection.selected.length > 0) {
//      this.isEditClientDisabled = false;
//      this.isTargetButtonDisabled = false;
//    } else {
//      this.isEditClientDisabled = true;
//      this.isTargetButtonDisabled = true;
//    }
//  }

//  masterToggle() {
//    this.isAllSelected() ?
//      this.selection.clear() :
//      this.dataSource.data.forEach(row => { this.selection.select(row) });
//    if (this.selection.selected.length > 0) {
//      this.isEditClientDisabled = false;
//      this.isTargetButtonDisabled = false;
//    } else {
//      this.isEditClientDisabled = true;
//      this.isTargetButtonDisabled = true;
//    }
//  }

 filterOptions(nameValue: string): ProjectManagement[] {
   if (!nameValue) {
     return this.projectManagement;
   }
   const filtered = this.projectManagement.filter((element) => {
     return (nameValue ? element.clientName.toLowerCase().includes
       (nameValue.toLowerCase()) : false) || (nameValue ? element.clientName.toLowerCase().includes
         (nameValue.toLowerCase()) : false)
   });
   return filtered;
 }

 radiobuttonClick(event, projectManagement: ProjectManagement): void {
   this.isRadionButtonClicked = true;
   this.isEditClientDisabled = false;
  //  if (projectManagement.isActive) {
  //    this.isTargetButtonDisabled = false;
  //  } else {
  //    this.isTargetButtonDisabled = true;
  //  }
   this.selectedProject = projectManagement;
 }

 onSearchClear() {
  this.searchKey = "";
  this.getProjects();
}

onClientChange({ value }) {
  console.log('Client changed...');
  this.searchKey = "";
  if (value === 'All') {
    this.selectedClient = "";
    this.getProjects();
  } else {
    this.selectedClient = value;
    this._localStorage.store('PageEvent', undefined);
    this.getProjects();
  }
}

getClients() {
  this.clientManagementService.getAllClientsNames()
    .subscribe(result => {
      if (!result) {
        return;
      }
      console.log(result);
      this.clients = result.clients;
    }, error => console.log(error));
}

}